import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import { DropDownOptions } from 'devextreme-react/select-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { DateBox, NumberBox, SelectBox, TextArea } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';
import $createDataSource from 'utils/create-data-souce-instance';
import { isSuccess } from 'utils/responseStatus';

import { DriversListItem } from 'bus/driverTransport/types';
import {
  useGetNomenclatureTransferDetailQuery,
  useLazyGetNomenclatureTransferDetailQuery,
  useLazyGetNomenclatureTransferTransportDetailQuery,
  useNomenclatureTransferTransportChangeMutation,
  useNomenclatureTransferTransportCreateMutation,
} from 'bus/nomenclatureTransfer/services';
import { NomenclatureTransferDetail } from 'bus/nomenclatureTransfer/types';

type CreateEditModalProps = {
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
  id: number | null;
  nomenclatureTransferId: number;
};

const initialForm: NomenclatureTransferDetail = {
  date: '',
  nomenclatureTransferId: 0,
  driverId: null,
  transportId: null,
  trailerId: null,
  quantity: 0,
  comment: '',
};

const CreateEditModal: FC<CreateEditModalProps> = ({ changeVisible, refresh, visible, id, nomenclatureTransferId }) => {
  let { id: pageId } = useParams<{ id: string }>();
  const [getNomenclatureTransferDetailQuery] = useLazyGetNomenclatureTransferDetailQuery();

  const [drivers, setDrivers] = useState<any>([]);

  const [nomenclatureTransferTransportChange, { isLoading: isLoadingChange }] =
    useNomenclatureTransferTransportChangeMutation();
  const [comingNomenclatureTransportCreate, { isLoading: isLoadingCreate }] =
    useNomenclatureTransferTransportCreateMutation();
  const [getComingNomenclatureTransportDetail] = useLazyGetNomenclatureTransferTransportDetailQuery();

  const isLoading = isLoadingChange || isLoadingCreate;

  let createFacroryGroupValidationRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<NomenclatureTransferDetail>(initialForm);

  const storeTransport: any = useMemo(() => {
    return $createDataSource('/v1/Transport', 'id', { defaultFilter: ['transportType', '=', '2'] });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const getDrivers = useCallback(async () => {
    if (!form.transportId) return [];
    const result: DriversListItem[] = await $createDataSource(
      `/v1/DriverTransport/${form.transportId}/drivers`,
      'driverId',
    ).load();
    setDrivers(
      result.map((item) => ({
        ...item,
        groupName: !item.isAttachedToCar ? 'Все водители' : 'Закрепленные за машиной',
      })),
    );
  }, [form.transportId]);

  useEffect(() => {
    getDrivers();
  }, [getDrivers]);

  const storeDriverTransport: any = useMemo(() => {
    if (!drivers.length) return [];
    return new DataSource({
      store: {
        type: 'array',
        data: drivers,
        key: 'driverId',
      },
      group: 'groupName',
      sort: [{ selector: 'groupName', desc: true }],
    });
  }, [drivers]);

  const storeTrailers = useMemo(() => {
    return $createDataSource('/v1/trailer', 'id');
  }, []);

  const onShown = async () => {
    if (id) {
      await getComingNomenclatureTransportDetail({ id }).unwrap().then(setForm);
    } else {
      getNomenclatureTransferDetailQuery({ id: pageId }).then((data) => {
        if (isSuccess(data)) {
          setForm(() => ({ ...initialForm, date: data.data?.date || '' }));
        }
      });
      setForm(initialForm);
    }
  };

  const onHidden = () => {
    setForm(initialForm);
    createFacroryGroupValidationRef.current?.instance.reset();
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createFacroryGroupValidationRef.current?.instance.validate().isValid) {
      const tempForm: NomenclatureTransferDetail = {
        ...form,
        id: Number(id),
        nomenclatureTransferId: nomenclatureTransferId,
      };

      if (id) {
        await nomenclatureTransferTransportChange(tempForm);
      } else {
        delete tempForm.id;
        await comingNomenclatureTransportCreate(tempForm);
      }
      changeVisible(false);
      refresh();
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Транспорт"
        width={700}
        onShowing={onShown}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createFacroryGroupValidationRef}>
                <Form id="test-facrory" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Дата" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="date"
                            onValueChange={(e) => {
                              setForm((prev) => ({ ...prev, date: e as string }));
                            }}
                            useMaskBehavior
                            dateSerializationFormat="yyyy-MM-ddTHH:mm:ssx"
                            value={form.date}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле дата" />
                            </Validator>
                          </DateBox>
                        </AppFiledBox>
                        <AppFiledBox label="Транспорт" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={storeTransport}
                            displayExpr="fullName"
                            valueExpr="id"
                            value={form.transportId}
                            searchEnabled
                            onItemClick={(e) => {
                              setForm((prev) => ({ ...prev, transportId: e.itemData.id }));
                            }}
                          >
                            <DropDownOptions title="Выберите Транспорт" closeOnOutsideClick={true} showTitle={false} />
                            <Validator>
                              <RequiredRule message="Выберите Транспорт" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>
                        <AppFiledBox label="Прицеп" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={storeTrailers}
                            displayExpr="number"
                            valueExpr="id"
                            value={form.trailerId}
                            searchEnabled
                            onItemClick={(e) => {
                              setForm((prev) => ({ ...prev, trailerId: e.itemData.id }));
                            }}
                          >
                            <DropDownOptions title="Выберите прицеп" closeOnOutsideClick={true} showTitle={false} />
                          </SelectBox>
                        </AppFiledBox>
                        <AppFiledBox label="Водитель" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={storeDriverTransport}
                            displayExpr="driverName"
                            valueExpr="driverId"
                            searchEnabled
                            value={form.driverId}
                            onItemClick={(e) => {
                              setForm((prev) => ({ ...prev, driverId: e.itemData.driverId }));
                            }}
                            grouped
                          >
                            <DropDownOptions title="Выберите водителя" closeOnOutsideClick={true} showTitle={false} />
                            <Validator>
                              <RequiredRule message="Выберите водителя" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>
                        <AppFiledBox label="Объем" labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="Объем"
                            format="#0.###"
                            max={99.99}
                            min={0}
                            value={form.quantity}
                            onValueChanged={(e) => {
                              setForm((prev) => ({ ...prev, quantity: e.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Объем" />
                            </Validator>
                          </NumberBox>
                        </AppFiledBox>
                        <AppFiledBox label="Комментарий" labelTop>
                          <TextArea
                            stylingMode="underlined"
                            placeholder="Введите комментарий"
                            mode="text"
                            value={form.comment || ''}
                            onChange={(e: any) => {
                              setForm((prev) => ({ ...prev, comment: e.event.currentTarget.value }));
                            }}
                          />
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={isLoading}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default CreateEditModal;
